import React from 'react';
import { Button} from 'antd-mobile';
import defaultImg from './default.png'

class carManage extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
        };
    }

    render() {
        
        return (
            <div className="carManageBox">
                <img src={defaultImg} style={{width: '100%'}}/>
            </div>
        );
    }
}
export default carManage;


// WEBPACK FOOTER //
// ./src/carManage/index/index.js